import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CuentaCorrienteBancoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CUENTA BANCO' htmlFor='input-cuentaCorrienteBanco' md={4} />
      <Col md={8}>
        <Field name='cuentaCorrienteBanco'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-cuentaCorrienteBanco'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaCorrienteBancoFormGroup)
